import css from 'styled-jsx/css';
import { colors } from '../../../themes/index';

export default css`
  .wrapper {
    background-color: #f1f1f1;
    padding-bottom: 0.5rem;
  }

  .alert {
    padding: 1em;
    overflow: hidden;
    background-color: #fffad5;
  }

  .alert p {
    color: #333;
    line-height: 1.2;
    margin: 0 0 1rem 0;
  }

  .alert.hidding {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.5s, opacity 0.5s linear, background-color 0.5s linear;
  }

  .alert :global(button) {
    float: right;
    color: ${colors.blue};
    border: 1px solid ${colors.blue};
    border-radius: 4px;
    text-transform: lowercase;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/ImprovedAlert/styles.js